"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenuItem = exports.TwsDropdownItem = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var standardItem = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: auto;\n\tpadding: ", " 16px;\n\tfont-size: 13px;\n\tfont-weight: ", ";\n\tline-height: 1.2em;\n"], ["\n\theight: auto;\n\tpadding: ", " 16px;\n\tfont-size: 13px;\n\tfont-weight: ", ";\n\tline-height: 1.2em;\n"])), globalVars_module_scss_1.default.spacing15, globalVars_module_scss_1.default.fontWeightNormal);
var sectionItem = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 36px;\n\tpadding: 9px 16px;\n\tbackground-color: ", ";\n\tfont-size: 10px;\n\tfont-weight: ", ";\n\tline-height: 1.1em;\n\ttext-transform: uppercase;\n"], ["\n\theight: 36px;\n\tpadding: 9px 16px;\n\tbackground-color: ", ";\n\tfont-size: 10px;\n\tfont-weight: ", ";\n\tline-height: 1.1em;\n\ttext-transform: uppercase;\n"])), globalVars_module_scss_1.default.tertiaryGray3, globalVars_module_scss_1.default.fontWeightThick);
var CloseIcon = styled_components_1.default.span.attrs({
    role: 'button',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tposition: absolute;\n\tright: 5px;\n\ttop: 2px;\n\ti {\n\t\tfont-size: 8px;\n\t}\n"], ["\n\tmargin-left: auto;\n\tposition: absolute;\n\tright: 5px;\n\ttop: 2px;\n\ti {\n\t\tfont-size: 8px;\n\t}\n"])));
CloseIcon.displayName = 'CloseIcon';
exports.TwsDropdownItem = styled_components_1.default.div.attrs({
    className: 'tws-dropdown-menuitem',
    role: 'menuitem',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: grid;\n\talign-items: center;\n\tcolor: ", ";\n\tcursor: pointer;\n\t", ";\n\t", ";\n\t&:not(:last-child):not(.menuitem-section) {\n\t\tborder-bottom: ", " solid ", ";\n\t}\n\t&:hover:not([disabled]):not(.menuitem-section) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tdisplay: grid;\n\talign-items: center;\n\tcolor: ", ";\n\tcursor: pointer;\n\t", ";\n\t", ";\n\t&:not(:last-child):not(.menuitem-section) {\n\t\tborder-bottom: ", " solid ", ";\n\t}\n\t&:hover:not([disabled]):not(.menuitem-section) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"])), globalVars_module_scss_1.default.mainGray, function (props) { return (props.section ? sectionItem : standardItem); }, function (props) { return (props.disabled ? 'color: ' + globalVars_module_scss_1.default.tertiaryGray2 : ''); }, globalVars_module_scss_1.default.border1, globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue);
var DropdownMenuItem = /** @class */ (function (_super) {
    __extends(DropdownMenuItem, _super);
    function DropdownMenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnClose = _this.handleOnClose.bind(_this);
        return _this;
    }
    DropdownMenuItem.prototype.render = function () {
        var _a = this.props, children = _a.children, closeIcon = _a.closeIcon, disabled = _a.disabled, onClick = _a.onClick, section = _a.section;
        var className = "".concat(section ? 'menuitem-section' : '');
        var handleOnClick = disabled ? undefined : onClick;
        return (React.createElement(exports.TwsDropdownItem, __assign({}, this.props, { onClick: handleOnClick, className: className }),
            closeIcon && (React.createElement(CloseIcon, { onClick: this.handleOnClose },
                React.createElement(Common_1.Icon, { name: 'close' }))),
            children));
    };
    DropdownMenuItem.prototype.handleOnClose = function () {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };
    return DropdownMenuItem;
}(React.Component));
exports.DropdownMenuItem = DropdownMenuItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
